import request from '@/utils/request'

const prefix = '/django_rest/job-question'

export default {
  getQuestionTemplateGroupList (params) {
    return request.get(`${prefix}-template/group/`, { params })
  },
  createQuestionTemplateGroup (group) {
    return request.post(`${prefix}-template/group/`, group)
  },
  updateQuestionTemplateGroup (groupId, data) {
    return request.put(`${prefix}-template/group/${groupId}`, data)
  },
  createQuestionTemplate (question) {
    return request.post(`${prefix}-template/question/`, question)
  },
  updateQuestionTemplate (questionId, data) {
    return request.put(`${prefix}-template/question/${questionId}`, data)
  },
  saveQuestionTemplateTree (data) {
    return request.post(`${prefix}-template/question-tree/`, data)
  },
  moveGroupQuestionTemplate (fromGroup, toGroup, question, moveTo, componentPayload = null) {
    const data = {
      from_group_id: fromGroup.id,
      to_group_id: toGroup.id,
      question_template_id: question.id,
      order: moveTo
    }
    if (componentPayload) {
      data.questions = componentPayload.questions
      data.original_question_ids = componentPayload.originalQuestionIds
    }
    return request.post(`${prefix}-template/question/move/`, data)
  },
  getDefaultQuestionTemplate (params) {
    return request.get(`${prefix}-template/question/default/`, { params })
  },
  getQuestionUpdateTaskList (params) {
    return request.get(`${prefix}/update/task/`, { params })
  },
  setOptionNextQuestion (jobId, questionId, optionId, data) {
    return request.put(`/django_rest/company/job/${jobId}/open-question/${questionId}/option/${optionId}/next/`, data)
  },
  removeOptionNextQuestion (jobId, questionId, optionId) {
    return request.delete(`/django_rest/company/job/${jobId}/open-question/${questionId}/option/${optionId}/next/`)
  },
  getNextQuestion (params) {
    return request.get('/django_rest/personal/job-questionnaire/next/', { params })
  }
}
